// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title[data-v-0b55b15f] {
  padding: 15px 15px 8px;
  font-size: 17px;
  color: var(--base-blue-color);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/search/myGroups.vue"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,eAAe;EACf,6BAA6B;AAC/B","sourcesContent":[".title[data-v-0b55b15f] {\n  padding: 15px 15px 8px;\n  font-size: 17px;\n  color: var(--base-blue-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
